import { render } from "./VideoUniq.vue?vue&type=template&id=5dcf701e"
import script from "./VideoUniq.vue?vue&type=script&lang=js"
export * from "./VideoUniq.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__